import { ChangeOrderSummary } from '@/features/ChangeOrder';

function ChangeOrder() {
  return <ChangeOrderSummary />;
}

export default ChangeOrder;
